import React from 'react'
import Icon from '../index'

const ImageIcon = ({ color, size }: any) => (
  <Icon color={color} size={size}>
    <path d="M14,10.8181818 L14,3.50964952 C14,3.22765279 13.7759869,3 13.4996527,3 L2.50034732,3 C2.22900057,3 2,3.22817786 2,3.50964952 L2,12.1818182 L4.75824553,9.67432225 C5.16790521,9.30190435 5.79525757,9.32806396 6.1639905,9.73776722 L7.06880734,10.7431193 L9.82559204,7.73571777 C10.1980573,7.32939207 10.8035382,7.33113256 11.174408,7.73571777 L14,10.8181818 Z M0,3.00585866 C0,1.89805351 0.894513756,1 1.99406028,1 L14.0059397,1 C15.1072288,1 16,1.89706013 16,3.00585866 L16,12.9941413 C16,14.1019465 15.1054862,15 14.0059397,15 L1.99406028,15 C0.892771196,15 0,14.1029399 0,12.9941413 L0,3.00585866 Z M4.5,7 C5.32842712,7 6,6.32842712 6,5.5 C6,4.67157288 5.32842712,4 4.5,4 C3.67157288,4 3,4.67157288 3,5.5 C3,6.32842712 3.67157288,7 4.5,7 Z" />
  </Icon>
)

ImageIcon.propTypes = {
  ...Icon.propTypes,
}

export default ImageIcon
